<script lang="ts">
  export let type: 'text' | 'square' | 'circle';
  export let size: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11;
</script>

<div role="presentation" data-type={type} style="---size: var(--size-{size})" />

<style>
  div {
    background-color: var(--elevation-2);
    border-radius: var(--radius-1);

    &[data-type='text'] {
      height: var(---size);
    }
    &[data-type='square'] {
      width: var(---size);
      height: var(---size);
    }
    &[data-type='circle'] {
      border-radius: var(--radius-full);
      width: var(---size);
      height: var(---size);
    }
  }
</style>
